// Redesign 2026 – carousel nabídky na mobilu (includes/template-parts/redesign/offer-slides.php).
// Na desktopu jsou tytéž karty dlaždicemi vedle sebe a JS nic nedělá. Pod $rd-bp posouvá pás karet
// (transform), ovládá tečky a šipky, reaguje na swipe a každých 6 s přejde na další kartu – mimo
// kurzor, dotyk a fokus uvnitř. Karty mimo záběr dostanou `inert`, aby na ně nešel Tab ani čtečka.
//
// Swipe: pás jede za prstem. Jakmile je tah zjevně vodorovný, svislý posun stránky se zastaví
// (preventDefault + CSS touch-action: pan-y) – jinak stránka při listování poskakovala nahoru a dolů
// podle toho, jak se prst mírně hýbe svisle. Svislý tah přes carousel dál normálně scrolluje stránku.

const MOBILE = window.matchMedia('(max-width: 899.98px)'); // $rd-bp v _tokens.scss
const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
const INTERVAL = 6000;
const SWIPE_MIN = 40; // px, kratší tah pás vrátí zpět
const AXIS_LOCK = 8; // px, po kolika se rozhodne, jestli je tah vodorovný nebo svislý
const EDGE_RESIST = 0.35; // za první / poslední kartu pás jen mírně povolí

function initSlides(root) {
  const track = root.querySelector('[data-rd-slides-track]');
  const items = Array.from(root.querySelectorAll('[data-rd-slides-item]'));
  const dots = Array.from(root.querySelectorAll('[data-rd-slides-dot]'));
  if (!track || items.length < 2) {
    return;
  }

  let index = 0;
  let timer = null;
  let paused = false;
  let touch = null; // { x, y, dx, axis: null | 'x' | 'y' }

  function render() {
    const carousel = MOBILE.matches;
    track.style.transform = carousel ? `translateX(${-100 * index}%)` : '';
    items.forEach((item, i) => {
      item.inert = carousel && i !== index;
    });
    dots.forEach((dot, i) => {
      if (i === index) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function go(i) {
    index = ((i % items.length) + items.length) % items.length;
    render();
  }

  function stop() {
    clearInterval(timer);
    timer = null;
  }

  function start() {
    stop();
    if (MOBILE.matches && !REDUCED_MOTION.matches) {
      timer = setInterval(() => {
        if (!paused) {
          go(index + 1);
        }
      }, INTERVAL);
    }
  }

  // Ruční přechod odkládá další automatický o celý interval.
  function goByUser(i) {
    go(i);
    start();
  }

  dots.forEach((dot, i) => dot.addEventListener('click', () => goByUser(i)));
  const prev = root.querySelector('[data-rd-slides-prev]');
  const next = root.querySelector('[data-rd-slides-next]');
  if (prev) {
    prev.addEventListener('click', () => goByUser(index - 1));
  }
  if (next) {
    next.addEventListener('click', () => goByUser(index + 1));
  }

  root.addEventListener('mouseenter', () => { paused = true; });
  root.addEventListener('mouseleave', () => { paused = false; });
  root.addEventListener('focusin', () => { paused = true; });
  root.addEventListener('focusout', (e) => {
    if (!root.contains(e.relatedTarget)) {
      paused = false;
    }
  });

  function drag(dx) {
    const atEdge = (index === 0 && dx > 0) || (index === items.length - 1 && dx < 0);
    track.style.transform = `translateX(calc(${-100 * index}% + ${atEdge ? dx * EDGE_RESIST : dx}px))`;
  }

  function endTouch() {
    if (!touch) {
      return;
    }
    const { axis, dx } = touch;
    touch = null;
    paused = false;
    track.style.transition = '';
    if (axis === 'x' && Math.abs(dx) > SWIPE_MIN) {
      goByUser(index + (dx < 0 ? 1 : -1));
    } else {
      render(); // vrátit pás na aktuální kartu
    }
  }

  root.addEventListener('touchstart', (e) => {
    if (!MOBILE.matches || e.touches.length > 1) {
      return;
    }
    touch = { x: e.touches[0].clientX, y: e.touches[0].clientY, dx: 0, axis: null };
    paused = true;
  }, { passive: true });

  // passive: false – jen tak jde při vodorovném tahu zastavit svislý posun stránky
  root.addEventListener('touchmove', (e) => {
    if (!touch || e.touches.length > 1) {
      return; // druhý prst = zoom, ne listování
    }
    const dx = e.touches[0].clientX - touch.x;
    const dy = e.touches[0].clientY - touch.y;
    if (!touch.axis) {
      if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) {
        return;
      }
      touch.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (touch.axis === 'x') {
        track.style.transition = 'none';
      }
    }
    if (touch.axis !== 'x') {
      return; // svislý tah – scrolluje stránka, carousel se nehýbe
    }
    if (e.cancelable) {
      e.preventDefault();
    }
    touch.dx = dx;
    drag(dx);
  }, { passive: false });

  root.addEventListener('touchend', endTouch);
  root.addEventListener('touchcancel', endTouch);

  const onMode = () => {
    render();
    start();
  };
  MOBILE.addEventListener('change', onMode);
  REDUCED_MOTION.addEventListener('change', start);

  root.classList.add('is-ready');
  onMode();
}

export default function initRedesignOfferSlides() {
  document.querySelectorAll('[data-rd-slides]').forEach(initSlides);
}
